import React, { useEffect, useState } from 'react'
import { Fade, Button } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { useHistory } from 'react-router'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import Page from 'redesign/components/templates/Page'
import routes from 'services/RoutesProvider/routes'
import { LOADING_CLOSE_BUTTON_TIME } from './constants'
import { Container } from './styles'

const PinLoadingContent: React.FC = () => {
  const history = useHistory()
  const { t } = useFavurTranslation()
  const [showCloseButton, setShowCloseButton] = useState(false)

  useEffect(() => {
    // Timer to show the close button
    const timer = setTimeout(() => setShowCloseButton(true), LOADING_CLOSE_BUTTON_TIME)

    return () => clearTimeout(timer)
  }, [])

  return (
    <Page fullContentHeight fullContentWidth showHamburgerHeader={false} hideNativeNavigation>
      <Container>
        <LoadingSpinner disableFullScreen />
        <Fade in={showCloseButton}>
          <Button color="secondary" onClick={() => history.push(routes.dashboard)}>
            {t('button.returnHome')}
          </Button>
        </Fade>
      </Container>
    </Page>
  )
}

export default PinLoadingContent
